import React, { useEffect, useState } from "react";
import { getAllItemsSearch } from "../../api/endpoints/search";
import { authSelector } from "../../store/selectors/index";
import { useSelector } from "react-redux";
import { Modal, message, Select } from "antd";
import { AiFillSave } from "react-icons/ai";
import { AiFillDelete } from "react-icons/ai";
import { LuView } from "react-icons/lu";
import { AiFillEdit } from "react-icons/ai";
import { AiFillFileAdd } from "react-icons/ai";
import { BiExit } from "react-icons/bi";
import OpeningSideBar from "../openingSideBar/openingSIdeBar";
// import "./party.css";
import { getAllParty } from "../../api/endpoints/party";
import {
  updateSingleVehical,
  deleteSingleVehical,
} from "../../api/endpoints/vehical";
import { createCoupon, deleteSingleCoupon, getAllCoupons, updateSingleCoupon } from "../../api/endpoints/couponIssued";
const { Option } = Select;

const Coupon = () => {
  const { user, access_token } = useSelector(authSelector);
  const [fieldsShow, setFieldsShow] = useState(false);
  const [type, setType] = useState("ADD");
  const [state, setState] = useState({
    id: "",
    parties: [],
    numberList: [],
    vehicalId: "",
    startingNumber: "",
    endingNumber: "",
    partyId: "",
    partyName: "",
    closed: "",
  });

  const clearState = () => {
    setState({
      id: "",
      parties: state.parties,
      numberList: state.numberList,
      vehicalId: "",
      startingNumber: "",
      endingNumber: "",
      partyId: "",
      partyName: "",
      closed: "",
    });
  };

  console.log(state, "Vall");

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };
  const addTank = async () => {
    setType("SAVE");
    setFieldsShow(true);
    setState({
      ...state,
      closed: 0,
    });
  };
  //   console.log(state.generalLedgerCode.length,"leng")
  const saveTank = async (e) => {
    if (
      !state.partyId ||
      !state.partyName ||
      !state.startingNumber ||
      !state.endingNumber
    ) {
      return message.error(
        `Please type ${
          !state.startingNumber
            ? "Starting Number"
            : !state.endingNumber
            ? "Ending Number"
            : !state.partyId
            ? "Account Number"
            : !state.partyName
            ? "Party Name"
            : ""
        }`
      );
    } else if (state.startingNumber > state.endingNumber) {
      return message.error("Incorrect Starting or Ending Number");
    }

    const payload = {
      partyId: state.partyId,
      startingNumber: state.startingNumber,
      endingNumber: state.endingNumber,
      grpId: Number(user.grpId),
      siteId: Number(user.siteId),
      companyCode: Number(user.companyCode),
    };

    console.log(payload, "payload");

    const results = await createCoupon(payload, access_token);
    if (results.success) {
      message.success(results.message || "Successfully entered!");
      clearState();
      setFieldsShow(false);
      setType("ADD");
    } else {
      message.error(results.message);
    }
  };

  const editTank = async () => {
    setType("EDIT");
    setFieldsShow(true);
  };

  const saveEditTank = async (e) => {
    if (type === "EDIT") {
      if (
        !state.partyId ||
        // !state.partyName ||
        !state.startingNumber ||
        !state.endingNumber
      ) {
        return message.error(
          `Please type ${
            !state.startingNumber
              ? "Starting Number"
              : !state.endingNumber
              ? "Ending Number"
              : !state.partyId
              ? "Account Number"
              // : !state.partyName
              // ? "Party Name"
              : ""
          }`
        );
      }
      const data = {
        id: state.id,
        partyId: Number(state.partyId),
        startingNumber: Number(state.startingNumber),
        endingNumber: Number(state.endingNumber),
      };
      console.log(data, "edite data");
      const results = await updateSingleCoupon(data, access_token);
      if (results.success) {
        message.success(results.message || "Successfully Updated!");
        clearState();
        setFieldsShow(false);
        setType("ADD");
      } else {
        message.error(results.message);
      }
    } else {
      if (!state.startingNumber && !state.endingNumber) return message.error("Please Select Vehical");
      modal.confirm({
        title: `Confirm`,
        content: "Are you sure you want to delete Coupon Book?",
        okText: "Delete",
        cancelText: "Cancel",
        onOk: confirmDeleteNozel,
      });
    }
  };
  const confirmDeleteNozel = async () => {
    const data = {
      id: state.id,
    };
    const results = await deleteSingleCoupon(data, access_token);
    if (results.success) {
      message.success(results.message || "Deleted Successfully!");
      clearState();
      setFieldsShow(false);
      setType("ADD");
    } else {
      message.error(results.message);
    }
  };

  const [modal, contextHolder] = Modal.useModal();
  const deleteNozel = async () => {
    setType("DELETE");
    setFieldsShow(true);
  };
  const confirmDelete = () => {
    modal.confirm({
      title: `Confirm`,
      content: "You want to delete Coupon Book?",
      okText: "Yes",
      cancelText: "Cancel",
      onOk: deleteNozel,
    });
  };

  const clearStates = () => {
    clearState();
    setFieldsShow(false);
    setType("ADD");
  };

  const getAllData = async () => {
    const _numberList = await getAllCoupons(access_token);
    const _parties = await getAllParty(access_token);
    setState({
      ...state,
      parties: _parties,
      numberList: _numberList,
    });
  };
  useEffect(() => {
    getAllData();

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  console.log(state, "state");
  return (
    <>
      <div className="flex bg-black main">
        <OpeningSideBar />
        <div className="h-full  flex flex-col content-center  w-full">
          <div className="flex justify-center">
            <div className="meterTableMain flex flex-col justify-items-center justify-center w-1/2 ml-10 mt-5 mr-10">
              <div className="bg-blue-500 headingBox flex justify-center">
                <h1 className="text-white">Register Coupon</h1>
                {contextHolder}
              </div>
              <div className="p-2 flex justify-center">
                {fieldsShow && (
                  <div className="w-70">
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white" htmlFor="fname">
                          Starting Number :
                        </label>
                        {type === "EDIT" || type === "DELETE" ? (
                          <>
                            <Select
                              className="bg-black text-slate-400 inpTxt  h-8 w-full"
                              showSearch
                              placeholder=""
                              optionFilterProp="children"
                              value={state.startingNumber || ""}
                              onChange={(e) => {
                                const _accountInfo = state.numberList.find(
                                  (el) => el.id === e
                                );
                                console.log("e", _accountInfo);

                                setState({
                                  ...state,
                                  id: e,
                                  startingNumber: _accountInfo.startingNumber,
                                  endingNumber: _accountInfo.endingNumber,
                                  partyId: _accountInfo.partyId,
                                  vehicalId: _accountInfo.vehicalId,
                                  // partyName: _accountInfo.party.partyName,
                                });
                              }}
                            >
                              {state.numberList.map((el) => (
                                // console.log(el, "el")
                                <Option value={el.id}>
                                  {`${el.startingNumber} - ${el.endingNumber}`}
                                </Option>
                              ))}
                            </Select>
                          </>
                        ) : (
                          <input
                            type="Number"
                            name="startingNumber"
                            value={state.startingNumber}
                            onChange={onChangeText}
                            className="bg-black text-slate-400 pl-2  inpTxt h-8 w-full"
                          />
                        )}
                      </div>
                      <div className="w-1/2 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          Ending Number :
                        </label>
                        <input
                          type="Number"
                          name="endingNumber"
                          value={state.endingNumber}
                          onChange={onChangeText}
                          className="bg-black text-slate-400 inpTxt p-2 h-8 w-full ml-3"
                        />
                      </div>
                    </div>

                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white" htmlFor="fname">
                          Party Id :
                        </label>
                        <Select
                          showSearch
                          className="text-black inpTxt  h-9 w-full"
                          placeholder="Party Id"
                          optionFilterProp="children"
                          value={state.partyId || "Party Id "}
                          onChange={(e) => {
                            const lCode = state.parties.find(
                              (el) => el.partyId === e
                            );
                            setState({
                              ...state,
                              partyId: e,
                              partyName: lCode.partyName,
                            });
                          }}
                        >
                          {state.parties.map((el) => (
                            <Option value={el.partyId}>{el.partyId}</Option>
                          ))}
                        </Select>
                      </div>
                      <div className="w-1/2 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          Party Name :
                        </label>
                        <Select
                          showSearch
                          className="text-black inpTxt  h-9 w-full ml-3"
                          placeholder="Party Name"
                          optionFilterProp="children"
                          value={state.partyName || "Party Name"}
                          onChange={(e) => {
                            const lCode = state.parties.find(
                              (el) => el.partyId === e
                            );
                            setState({
                              ...state,
                              partyId: e,
                              partyName: lCode.partyName,
                            });
                          }}
                        >
                          {state.parties.map((el) => (
                            <Option value={el.partyId}>{el.partyName}</Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white" htmlFor="fname">
                          Closed:
                        </label>
                        <Select
                          showSearch
                          className="text-black inpTxt  h-9 w-full"
                          placeholder="No"
                          optionFilterProp="children"
                          value={state.closed === "" ? "No" : state.closed}
                          onChange={(value) =>
                            onChangeText({ target: { name: "closed", value } })
                          }
                        >
                          <Option value={0} name="closed">
                            No
                          </Option>
                          <Option value={1} name="closed">
                            Yes
                          </Option>
                        </Select>
                      </div>
                      {type === "EDIT" && (
                        <div className="w-1/2 mb-3">
                          <label className="text-white ml-3" htmlFor="fname">
                            Edit Starting Number :
                          </label>
                          <input
                            type="Number"
                            name="startingNumber"
                            value={state.startingNumber}
                            onChange={onChangeText}
                            className="bg-black text-slate-400 pl-2 ml-3  inpTxt h-8 w-full"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div class="flex justify-center pb-3">
                {type === "ADD" && (
                  <button
                    onClick={addTank}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 py-1 px-4 rounded"
                  >
                    <AiFillFileAdd className="mr-2 mt-1" />

                    <span>Add</span>
                  </button>
                )}

                {type === "SAVE" && (
                  <button
                    onClick={saveTank}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 py-1 px-4 rounded"
                  >
                    <AiFillSave className="mt-1 mr-2 " />
                    <span>Save</span>
                  </button>
                )}
                {type === "ADD" && (
                  <button className="bg-blue-500 hover:bg-blue-700 flex text-white ml-2 mt-3 py-1 px-4 rounded">
                    <LuView className="mt-1 mr-2 " />
                    <span>View</span>
                  </button>
                )}
                {type === "ADD" && (
                  <button
                    onClick={editTank}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                  >
                    <AiFillEdit className="mr-2 mt-1" />

                    <span>Edit</span>
                  </button>
                )}

                {(type === "EDIT" || type === "DELETE") && (
                  <button
                    onClick={saveEditTank}
                    className="bg-blue-500 hover:bg-blue-700 text-white ml-2 mt-3 py-1 px-4 rounded"
                  >
                    DONE
                  </button>
                )}
                {type === "ADD" && (
                  <button
                    onClick={confirmDelete}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                  >
                    <AiFillDelete className="mr-2 mt-1" />

                    <span>Delete</span>
                  </button>
                )}
                {type !== "ADD" && (
                  <button
                    onClick={clearStates}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                  >
                    <BiExit className="mr-2 mt-1" />
                    <span>Exit</span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Coupon;
